import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectHasFulfillableContract, selectIsQualifiedForMarket, } from "../../selectors/selectContractInfo";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { ButtonNormalSmall } from "../generic/common/ButtonNormalSmall";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var _HudButtonMarket = function (_a) {
    var onOpenMarketMenu = _a.onOpenMarketMenu, canUseMarket = _a.canUseMarket, hasFulfillableContract = _a.hasFulfillableContract;
    var CheckBadge = hasFulfillableContract ? (React.createElement(Badge, { position: IdBadgePosition.TopRight },
        React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: IdIcon.QuestFinishIcn }))) : (undefined);
    return (React.createElement("div", { className: "hud-player-base-market" },
        React.createElement(ButtonNormalSmall, { onClick: onOpenMarketMenu, className: !canUseMarket ? IdStyles.StateLocked : "" },
            React.createElement("div", { className: "flex flex--guts w100 h100" },
                React.createElement(Icon, { icon: IdIcon.ContractsMarketIcn, styleId: IdStyles.IconLarge, isLocked: !canUseMarket }),
                CheckBadge))));
};
var mapState = function (state) { return ({
    canUseMarket: selectIsQualifiedForMarket(state),
    hasFulfillableContract: selectHasFulfillableContract(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onOpenMarketMenu: function () { return dispatch(actionModalOpen(IdModal.Market)); },
}); };
export var HudButtonMarket = connect(mapState, mapDispatch)(_HudButtonMarket);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/HudButtonMarket.tsx
// module id = 2269
// module chunks = 3